import { render } from "./EmployeeLevelEdit.vue?vue&type=template&id=60d54d76&scoped=true"
import script from "./EmployeeLevelEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeLevelEdit.vue?vue&type=script&lang=js"

import "./EmployeeLevelEdit.vue?vue&type=style&index=0&id=60d54d76&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d54d76"]])

export default __exports__